import React, { PureComponent } from 'react'
import { View, Text } from 'react-native'
import styled from 'styled-components/native'
import { lighten } from 'polished'

import theme from '../../../styles/theme'

const ErrorBox = styled(View)`
  margin: ${theme.gutterUnit}px;
  padding: ${2 * theme.gutterUnit}px;
  border-width: 1px;
  border-color: ${theme.colours.error};
  background-color: ${lighten(0.6, theme.colours.error)};
`

const ErrorMessage = styled(Text)`
  color: ${theme.colours.error};
`

export default class InlineError extends PureComponent {
  render () {
    const { message } = this.props
    const retryMessage = '(Try refreshing your web browser)'
    return (
      <ErrorBox>
        <ErrorMessage>{`${message}${message === 'Timeout error' ? ` ${retryMessage}` : ''}`}</ErrorMessage>
      </ErrorBox>
    )
  }
}
